import { configureStore } from '@reduxjs/toolkit';

import modal from '@/redux/reducer/modal-reducer';
import session from '@/redux/reducer/session';

export const store = configureStore({
  reducer: {
    session,
    modal,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
